import { props, state } from 'cerebral/tags'
import { set, increment } from 'cerebral/operators'
import loadOrderHistory from '../actions/loadOrderHistory'
import setCurrentView from 'modules/App/factories/setCurrentView'
import getFirstOrderId from '../actions/getFirstOrderId'
import loadOrderById from './loadOrderById'

export default [
  set(state`orderHistory.skip`, 0),
  loadOrderHistory,
  {
    loaded: [
      set(state`orderHistory.history`, props`orders`),
      set(state`orderHistory.count`, props`count`),
      increment(state`orderHistory.skip`, state`orderHistory.limit`),
      getFirstOrderId,
      ...loadOrderById
    ],
    noOrders: []
  },
  setCurrentView({ view: 'orderHistory', showSort: false })
]



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/chains/loadOrderHistory.js